module.exports = __webpack_public_path__ + "assets/img/img-care-banner-xs.b8a22cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/care/img-care-banner-xs.jpg
// module id = 1093
// module chunks = 1